const EnvironmentEnum = {
  Local: 'local',
  Development: 'development',
  Release: 'release',
  Production: 'production',
  Test: 'test',
};
export default EnvironmentEnum;
